/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps } from '@mui/material';

export const productCardInventoryTitleSX: SxProps = {
	mx: 0.5,
	fontSize: '12px',
};
